import React from 'react';
import PropTypes from 'prop-types';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { NumericFormat } from 'react-number-format';

export default function ProductDetails(props) {
    return (
        <div>
            <p>Designed to help give loved ones a lifetime of protection at an economical monthly rate that will never increase. This product is a whole life insurance policy, meaning that it builds cash value.
            In addition, this premium will never increase for any reason. It's that simple.
                    </p>

            <p><strong>For Individuals Seeking the Following:</strong></p>
            <ul>
                <li>Don't want to hassle with medical exams</li>
                <li>Guaranteed premium, death benefit and cash values</li>
                <li>Permanent insurance that can last a lifetime</li>
            </ul>

            <p><strong>Product Information</strong></p>
            <ul>
                <li>Ages 18 to 65</li>
                <li>Coverage Amounts up to $150,000</li>
            </ul>

            <p><strong>Additional product features:</strong></p>
            <ul>
                <li>Guaranteed death benefit</li>
                <li>Cash accumulates at a guaranteed interest rate of 4%</li>
                <li>Guarantees are subject to the financial strength and claims-paying ability of the issuing insurance company</li>
            </ul>

            <Button variant="text" color="secondary" onClick={props.setProductInfoDialogOpen}>View detailed product information</Button>

            <p><strong>Cash Values</strong></p>

            <TableContainer>
                <Table aria-label="Cash Value">
                    <TableHead>
                        <TableRow className="cash-value-header">
                            <TableCell>Year 5</TableCell>
                            <TableCell>Year 10</TableCell>
                            <TableCell>Year 20</TableCell>
                            <TableCell>Year 30</TableCell>
                            <TableCell>At Age 65</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key={0}>
                            {props.cashValues.map((cashValue, index) =>
                                <TableCell key={index} component="th" scope="row" className="text-center">
                                    <NumericFormat value={cashValue} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                </TableCell>
                            )}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <p><small className='fw-bolder'>Not FDIC/NCUA Insured; Not Bank Or Credit Union Guaranteed; Not A Deposit; Not Insured By Any Federal Government Agency.</small></p>

        </div>
    )
}

ProductDetails.propTypes = {
    cashValues: PropTypes.array.isRequired
};
